import { formatPrice } from "../../../../common/utils"
import { PropertyPin } from "../../data"

/* Toolkit map-all-pins port (#855) — the pure halves: extra-pin selection,
   dot marker + compact card HTML. Provider-free so it unit-tests without
   booting Leaflet; the wiring lives in LeafletMap.tsx. */

export type AllPinsConfig = {
  enabled?: boolean
}

export function resolveAllPins(config: AllPinsConfig | undefined): { enabled: boolean } {
  return { enabled: config?.enabled === true }
}

/* The full-set pins minus the homes already on the map as real (price-badge)
   markers: as pages load in, the matching dots disappear. Coordinates were
   validated at the fetch boundary (data.ts), so no re-check here. */
export function extraPinsFor(pins: PropertyPin[], renderedIds: ReadonlySet<string>): PropertyPin[] {
  return pins.filter((pin) => !renderedIds.has(pin.id))
}

export function escapeHtml(value: unknown): string {
  return String(value ?? '')
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#039;')
}

export const DOT_PIN_SIZE = 16

/* Lightweight dot marker for a home beyond the loaded page. The title rides
   the native tooltip; the compact card opens on click. */
export function dotPinHtml(pin: PropertyPin): string {
  return `<div class="hfse-allpins-dot" title="${escapeHtml(pin.title)}"></div>`
}

/* Compact click card. Skinny pins carry no image and (in the v1 payload shape)
   no price — title plus a PDP link is the whole card; a priced pin (the
   central#3106 optional extras) gains a "From $X" line. */
export function pinCardHtml(pin: PropertyPin, pdpUrl: string | null): string {
  const priceText = pin.price && pin.price > 0
    ? `From ${formatPrice(pin.price, pin.currency || 'USD')}`
    : ''
  const body =
    `<div class="hfse-allpins-card-body">` +
    `<div class="hfse-allpins-card-title">${escapeHtml(pin.title)}</div>` +
    `<div class="hfse-allpins-card-price">${priceText ? escapeHtml(priceText) : 'View home'}</div>` +
    `</div>`
  return pdpUrl
    ? `<a class="hfse-allpins-card" href="${escapeHtml(pdpUrl)}" target="_blank" rel="noopener">${body}</a>`
    : `<div class="hfse-allpins-card">${body}</div>`
}
